import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwtMediaModule } from '@cawita/core-front/asset';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { SharedCommonModule } from '../../../../modules';
import { MediaAvatarAddonComponent } from './media-avatar-addon.component';
import { MediaLoadingAddonComponent } from './media-loading-addon.component';
import { MediaIconAddonComponent } from './media-icon-addon.component';
import { MediaTextAddonComponent } from './media-text-addon.component';


@NgModule({
  declarations: [
    MediaAvatarAddonComponent,
    MediaLoadingAddonComponent,
    MediaTextAddonComponent,
    MediaIconAddonComponent
  ],
  imports: [
    CommonModule,
    SharedCommonModule,
    NzSkeletonModule,
    CwtMediaModule
  ],
  exports: [
    MediaAvatarAddonComponent,
    MediaLoadingAddonComponent,
    MediaIconAddonComponent,
    MediaTextAddonComponent,
    CwtMediaModule
  ]
})
export class SharedMediaModule { }
